/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { useInsightContentData } from 'hooks/useInsightModalState'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import { Status } from 'features/types'
import SpinningQ from 'components/share/SpinningQ'
import { useSysTheme } from 'hooks/useUiState'
import { SystemTheme } from 'hooks/useUiState/types'

// eslint-disable-next-line react/prop-types
const InsightContentLoadingGuard = ({ children }: { children: React.ReactNode }) => {
  const theme = useSysTheme() as SystemTheme
  const insightContentData = useInsightContentData<{
    status: Status
    data: any[]
  }>(InsightContentType.FLUCTUATION_SUMMARY_METRICS)

  if (!insightContentData || insightContentData.status === 'loading')
    return <SpinningQ size={32} color={theme.text.primary} />

  return <>{children}</>
}

export default InsightContentLoadingGuard
